import styled from 'styled-components';

import ContentHeaderStyled from '../../../components/ContentHeader';
import HoverableCard from '../../../components/HoverableCard';
import PaginationStyled from '../../../components/Pagination';
import { CHART_DESCRIPTIONS } from '../chartDescriptions';

interface Props {
  className?: string;
}

const BarsPage = ({ className = '' }: Props) => (
  <div className={className}>
    <div className="content">
      <ContentHeaderStyled
        className="breadcrumbs"
        title="Bars"
        breadcrumbs={[
          { label: 'Data Visualization', url: '/data-visualization' },
          { label: 'Bars Chart' },
        ]}
      />

      <div className="cards">
        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/chart-v']}
          title="Bar Chart - V"
          url="chart-v"
          image="/images/data-viz-bars/bar-chart-v.png"
          tags={['comparison']}
        />
        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/chart-h']}
          title="Bar Chart - H"
          url="chart-h"
          image="/images/data-viz-bars/bar-chart-h.png"
          tags={['comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/grouped-bar-chart-v']}
          title="Grouped Bar Chart - V"
          url="grouped-bar-chart-v"
          image="/images/data-viz-bars/grouped-bar-chart-v.png"
          tags={['comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/grouped-bar-chart-h']}
          title="Grouped Bar Chart - H"
          url="grouped-bar-chart-h"
          image="/images/data-viz-bars/grouped-bar-chart-h.png"
          tags={['comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/stacked-bar-chart-v']}
          title="Stacked Bar Chart - V"
          url="stacked-bar-chart-v"
          image="/images/data-viz-bars/stacked-bar-chart-v.png"
          tags={['comparison', 'proportion']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/stacked-bar-chart-h']}
          title="Stacked Bar Chart - H"
          url="stacked-bar-chart-h"
          image="/images/data-viz-bars/stacked-bar-chart-h.png"
          tags={['comparison', 'proportion']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/lollipop-v']}
          title="Lollipop - V"
          url="lollipop-v"
          image="/images/data-viz-bars/lollipop-v.png"
          tags={['comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/lollipop-h']}
          title="Lollipop - H"
          url="lollipop-h"
          image="/images/data-viz-bars/lollipop-h.png"
          tags={['comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/grouped-lollipop-v']}
          title="Grouped Lollipop - V"
          url="grouped-lollipop-v"
          image="/images/data-viz-bars/grouped-lollipop-v.png"
          tags={['comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/grouped-lollipop-h']}
          title="Grouped Lollipop - H"
          url="grouped-lollipop-h"
          image="/images/data-viz-bars/grouped-lollipop-h.png"
          tags={['comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/stacked-lollipop-v']}
          title="Stacked Lollipop - V"
          url="stacked-lollipop-v"
          image="/images/data-viz-bars/stacked-lollipop-v.png"
          tags={['comparison', 'proportion']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/stacked-lollipop-h']}
          title="Stacked Lollipop - H"
          url="stacked-lollipop-h"
          image="/images/data-viz-bars/stacked-lollipop-h.png"
          tags={['comparison', 'proportion']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/funnel-chart']}
          title="Funnel Chart"
          url="funnel-chart"
          image="/images/data-viz-bars/funnel-chart.png"
          tags={['comparison', 'proportion']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/bars/histogram']}
          title="Histogram"
          url="histogram"
          image="/images/data-viz-bars/histogram.png"
          tags={['distribution', 'trend']}
        />
      </div>

      <PaginationStyled
        previousLink="/data-visualization/lines"
        previous="Lines"
        nextLink="/data-visualization/maps"
        next="Maps"
        className="footer-pagination"
      />
    </div>
  </div>
);

const StyledBarsPage = styled(BarsPage)`
  > .content {
    overflow-x: hidden;
    margin: 0 auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 100%;

    > .breadcrumbs {
      margin-bottom: 24px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        margin-bottom: 40px;
      }
    }

    > .cards {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        grid-template-columns: repeat(2, 1fr);
        margin-bottom: 80px;
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    > .footer-pagination {
      display: none;
      margin-top: auto;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        display: block;
      }
    }
  }
`;

export default StyledBarsPage;
